<template>
	<el-dialog :visible.sync="is_visible" :width="'40%'" @close="close">
		<template slot="title">
			<div v-if="!is_attachment_only">
				<h3 class="mb-0 font-weight-500">{{ is_update ? 'Update Collection' : 'Add Collection' }}</h3>
			</div>
			<div v-else>
				<h3 class="mb-0 font-weight-500">Attachments</h3>
			</div>
		</template>
		<b-form role="form">
			<b-row>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Select Account Group">
						<el-select v-model="form.account_group" placeholder="Select" required>
							<el-option :label="'No Selected'" :value="null"></el-option>
							<el-option  v-for="([key, value]) in accountGroupList" :key="key" :label="value" :value="value">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Pay Method">
						<el-radio-group size="small" v-model="form.pay_method" fill="#13663E">
							<el-radio-button label="Bank Transfer"></el-radio-button>
							<el-radio-button label="Cash"></el-radio-button>
							<el-radio-button label="Cheque"></el-radio-button>
							<el-radio-button label="Adv. Instalment"></el-radio-button>
						</el-radio-group>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only && ['Repayment','Redemption','Advance Payment'].includes(form.account_group)">
					<b-form-group label="Select Instalment Month">
						<el-select v-model="form.rpay_id" placeholder="Select" @change="setAmount($event)">
							<el-option :label="'No Selected'" :value="null"></el-option>
							<el-option v-for="(item,index) in unPaidRepayments" :key="index" :label="'Continuance ' + item.instalment_mth + ' Period '+ _gHlp.formatMomentDate(item.due_date,'D MMM, YYYY')"
								:value="item.rpay_id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Amount (RM)">
						<CurrencyInput v-model="form.amount"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
						<small v-if="!_gHlp.isEmpty(repayment_notif)" class="text-danger">{{ repayment_notif }}</small>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only && ['Manual Adjustment','Other'].includes(form.account_group)">
					<b-form-group label="Transaction Type">
						<b-form-radio-group v-model="form.transaction">
							<b-form-radio value="Debit">Debit</b-form-radio>
							<b-form-radio value="Credit">Credit</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Pay Date">
						<el-date-picker v-model="form.pay_date" type="date" value-format="yyyy-MM-dd" placeholder="Pick a day">
						</el-date-picker>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Paid Status">
						<el-radio-group size="small" v-model="form.paid_status" fill="#13663E">
							<el-radio-button value="Pending" label="Pending"></el-radio-button>
							<el-radio-button value="Paid" label="Paid"></el-radio-button>
						</el-radio-group>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Receipt No:">
						<b-form-input v-model="form.receipt_no" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Remarks">
						<b-form-textarea v-model="form.remarks" placeholder="Write remarks here"></b-form-textarea>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group :label="!is_attachment_only ? 'Add Attachment (Optional)': null">
						<UploadFiles @addFiles="addFiles" />
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<div class="card-table-simple mb-5" v-loading="is_loading_attachment">
						<b-table-simple responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th>Doc Name</b-th>
									<b-th v-if="is_update">Uploaded by</b-th>
									<b-th v-if="is_update">Date</b-th>
									<b-th></b-th>
								</b-tr>
							</b-thead>
							<b-tbody v-if="!_gHlp.isEmpty(currentAttachments) || !_gHlp.isEmpty(newAttachments)">
								<template v-if="is_update">
									<b-tr v-for="(data, index) in currentAttachments" :key="index">
										<b-td @click="$refs.preview_modal.preview(data.url, data.original_filename)"
											class="cursor-pointer text-primary font-weight-500">{{ data.filename }}</b-td>
										<b-td>{{ data.created_by_detail.name }}</b-td>
										<b-td>{{ data.created_at | dateFormatString }}</b-td>
										<b-td>
											<svg @click="deleteFile(data)" xmlns="http://www.w3.org/2000/svg"
												class="text-danger cursor-pointer" width="14" height="18" viewBox="0 0 448 512">
												<path fill="currentColor"
													d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
											</svg>
										</b-td>
									</b-tr>
								</template>
								<b-tr v-for="(data, index) in newAttachments" :key="index">
									<b-td class="cursor-pointer text-primary font-weight-500">{{ data.upload.filename }}</b-td>
									<b-td v-if="is_update">-</b-td>
									<b-td v-if="is_update">-</b-td>
									<b-td>
										<svg @click="removeFile(data)" xmlns="http://www.w3.org/2000/svg" class="text-danger cursor-pointer"
											width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
										</svg>
									</b-td>
								</b-tr>
							</b-tbody>
							<b-tbody v-else>
								<b-tr>
									<b-td :colspan="is_update ? 4 : 2">No Attachment</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</b-col>
				<b-col cols="12" class="text-center">
					<el-button class="bg-primary text-white w-100" @click.prevent="submit()" :loading="is_loading_btn">Save</el-button>
				</b-col>
			</b-row>
		</b-form>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</el-dialog>
</template>
<script>
import { Select, Option, Button, DatePicker, RadioGroup, RadioButton, Dialog } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import UploadFiles from '@/views/Widgets/UploadFiles'
import { swal } from '@/assets/js/httpImports.js';
import { cloneDeep } from 'lodash'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useAttachmentStore } from '@/stores/attachmentStore';
import PreviewModal from '@/components/Modal/PreviewModal';

export default {
	// props: ['editData'],
	components: {
		CurrencyInput,
		UploadFiles,
		PreviewModal,
		[Dialog.name]: Dialog,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
	},
	data() {
		return {
			is_visible: false,
			is_update: false,
			is_loading_attachment: false,
			is_loading_btn: false,
			is_attachment_only: false,
			form: {
				rpay_id: null,
				pay_method: '',
				receipt_no: '',
				amount: '',
				transaction: '',
				pay_date: '',
				instalment_month: '',
				paid_status: '',
				account_group: '',
				remarks: '',
				status: ''
			},
			repayment_notif:'',
			unPaidRepayments: [],
			newAttachments: [],
			currentAttachments: [],
			deleteAttachments: [],
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeRepayments','activeUnpaidRepayments']),
		accountGroupList(){
			return Object.entries(_gConst.paymentCategory)
		}
	},
	watch: {
		// editData: {
		// 	handler(newVal) {
		// 		if (!_gHlp.isEmpty(newVal)) {
		// 			this.setForm(newVal);
		// 		} else {
		// 			// this.clean();
		// 		}
		// 	},
		// 	immediate: true
		// }
	},
	created() {
	},
	methods: {
		...mapActions(useLoanCaseStore, ['createColl', 'updateColl']),
		...mapActions(useCustomerStore, ['getDocTypes', 'getCustDocs', 'downloadCustDoc', 'removeCustDoc']),
		...mapActions(useAttachmentStore, ['getAttachmentList', 'detailAttachment', 'uploadAttachment', 'deleteAttachment']),
		show(editData=null, attachment_only=false){
			this.unPaidRepayments = cloneDeep(this.activeUnpaidRepayments);
			if (!_gHlp.isEmpty(editData)) {
				this.setForm(editData);
				let currRepayment = this.activeUnpaidRepayments.find(itm => itm.rpay_id == editData.rpay_id);
				if(_gHlp.isEmpty(currRepayment)){
					currRepayment = this.activeRepayments.find(itm => itm.rpay_id == editData.rpay_id);
					if(!_gHlp.isEmpty(currRepayment)) {
						this.unPaidRepayments.push(currRepayment);
					}
				}
			}
			this.is_attachment_only = attachment_only;
			this.is_loading_btn = false
			this.is_visible = true
		},
		close() {
			this.clean();
			this.is_loading_btn = false
			this.is_visible = false
		},
		clean() {
			this.form = {
				rpay_id: null,
				pay_method: '',
				receipt_no: '',
				amount: '',
				transaction: '',
				pay_date: '',
				instalment_month: '',
				paid_status: '',
				account_group: '',
				remarks: '',
				status: ''
			}
			this.newAttachments = [];
			this.currentAttachments = [];
			this.deleteAttachments = [];
			this.is_update = false
			this.repayment_notif = ''
		},
		setForm(editData) {
			// this.clean();
			this.is_update = true;
			this.form = editData;
			this.form.amount = this.form.transaction == 'Debit' ?  editData.debit :  editData.credit;
			this.getAttachments();
		},
		setAmount(val){
			const repayments = this.unPaidRepayments.filter(itm => itm.rpay_id <= val)
			const repayment = this.unPaidRepayments.find(itm => itm.rpay_id == val)
			if(_gHlp.isEmpty(repayments)){
				this.form.amount = 0;
				this.form.pay_date = '';										
				this.form.instalment_month = '';										
				this.repayment_notif = '';	
				return;									
			}

			const totalRepaid = repayments.reduce((tot, obj) => {
															return tot + parseFloat(obj.repayment_amt);
													},0)
			const totalLateCharge = repayments.reduce((tot, obj) => {
															return tot + parseFloat(obj.late_charge_amt);
													},0)
			const totalLateDays = repayments.reduce((tot, obj) => {
															return tot + parseInt(obj.late_days);
													},0)

			this.repayment_notif = 'Repayment for '+repayments.length + ' Period (RM '+totalRepaid.toFixed(2)+')';
			if(!_gHlp.isEmpty(totalLateCharge) && (totalLateCharge > 0)){
				this.repayment_notif += ' + Late Charge for '+totalLateDays+' Days (RM '+totalLateCharge.toFixed(2)+')';
			}										
												
			this.form.amount = parseFloat(totalRepaid) + parseFloat(totalLateCharge);
			this.form.pay_date = _gHlp.getCurrentDateTime(false);										
			this.form.instalment_month = repayment.due_date;										
		},
		addFiles(items) {
			for (let i = 0; i < items.length; i++) {
				this.newAttachments.push(items[i]);
			}
		},
		removeFile(file) {
			this.newAttachments = this.newAttachments.filter(item => {
				return item.upload.uuid != file.upload.uuid;
			});
		},
		submit() {
			this.is_loading_btn = true;

			if(['Disbursement','Late Charge','Interest','Manual Fee Charge'].includes(this.form.account_group)){
				this.form.transaction = 'Credit'
			}
			if(['Repayment','Redemption','Advance Payment','Late Charge - Waived','Manual Rebate'].includes(this.form.account_group)){
				this.form.transaction = 'Debit'
			}
		
			const params = {
				...this.form,
				total_attachment: this.currentAttachments.length + this.newAttachments.length,
				debit: this.form.transaction == 'Debit' ? this.form.amount : 0,
				credit: this.form.transaction == 'Credit' ? this.form.amount : 0,
				status: (this.is_attachment_only) ? this.form.status : 'Pending'
			};
			if (this.form.lcol_id) {
				this.updateColl(this.form.lcol_id, params).then((resp) => {
					this.submitUploadAttachments();
					this.submitRemoveAttachments();
					gEventBus.$emit('refresh-cases');
					this.$emit('closeModal',true);
					_gNotif.notifySuccess('<b>Collection</b> - Successfully Updated.')
					this.is_loading_btn = false;
					this.is_visible = false
				});
			} else {
				this.createColl(params).then((resp) => {
					gEventBus.$emit('refresh-cases');
					this.form.lcol_id = resp.lcol_id;
					this.form.case_id = resp.case_id;
					this.submitUploadAttachments();
					this.$emit('closeModal',true);
					_gNotif.notifySuccess('<b>Collection</b> - Successfully Created.')
					this.is_loading_btn = false;
					this.is_visible = false
				});
			}
		},

		submitRemoveAttachments() {
			if (_gHlp.isEmpty(this.deleteAttachments)) return false
			for (let i = 0; i < this.deleteAttachments.length; i++) {
				const itm = this.deleteAttachments[i];
				this.deleteAttachment(itm)
			}
		},
		submitUploadAttachments() {
			if (_gHlp.isEmpty(this.newAttachments)) return false
			let attachments = this.newAttachments;
			let owner_type = 'loan_collection';
			let owner_id = this.form.lcol_id;
			let tags = 'lms_' + this.form.case_id + '_case';

			for (let i = 0; i < this.newAttachments.length; i++) {
				const itm = this.newAttachments[i];
				let params = {
					folder: 'lms/' + owner_type + '/' + owner_id,
					owner_type: owner_type,
					owner_id: owner_id,
					// attachment_category_id: null,
					attachment_tags: tags,
					file: itm
				}
				this.uploadAttachment(params)
			}
		},
		getAttachments() {
			this.is_loading_attachment = true;
			this.getAttachmentList({ owner_id: this.form.lcol_id, owner_type: 'loan_collection' }).then(resp => {
				this.currentAttachments = resp.data;
				this.is_loading_attachment = false;
			}).catch(e => {
				_gNotif.errorFunction(e);
				this.is_loading_attachment = false;
			});
		},
		deleteFile(attachment) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					if (_gHlp.isEmpty(this.currentAttachments)) return false
					this.currentAttachments = this.currentAttachments.filter(item => {
						return item.attachment_id != attachment.attachment_id;
					});
					this.deleteAttachments.push(attachment.attachment_id)
				}
			});
		}
	}
}
</script>